import React from 'react';

const EditQuiz = () => {
    return (
        <div>EditQuiz</div>
    );
}

export default EditQuiz;